export const comics = [
  {
    id: 1,
    title: "星光坠落时",
    author: "金秀雅",
    category: "恋爱",
    rating: 9.6,
    status: "连载中",
    chapters: 87,
    views: "3280万",
    description: "当红偶像练习生林星辰在一次意外中穿越到了平行世界，变成了一个默默无闻的练习生。在这个世界里，她遇到了冷酷孤傲的顶流歌手韩在宇。两人从互相看不顺眼到逐渐被彼此吸引，一段甜中带虐的娱乐圈恋爱故事就此展开。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20beautiful%20young%20couple%20under%20starlight%2C%20soft%20pink%20and%20golden%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background%20with%20sparkles%2C%20romantic%20webtoon%20style%20illustration%2C%20modern%20K-drama%20aesthetic%2C%20high%20quality%20digital%20art%2C%20soft%20lighting%2C%20elegant%20character%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    tags: ["娱乐圈", "甜宠", "穿越"],
    updateTime: "2026-07-03"
  },
  {
    id: 2,
    title: "魔王的契约新娘",
    author: "李恩智",
    category: "奇幻",
    rating: 9.4,
    status: "连载中",
    chapters: 124,
    views: "5120万",
    description: "平凡的大学生尹夏琳意外被召唤到了魔王城，成为了传说中魔王的第一百位契约新娘。然而这位魔王大人似乎和传闻中完全不同——他温柔体贴又有点天然呆。在解开魔王诅咒的过程中，两人渐渐发现彼此命运早已交织。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20mysterious%20handsome%20demon%20king%20and%20innocent%20bride%2C%20dark%20purple%20and%20gold%20color%20scheme%2C%20magical%20castle%20background%2C%20romantic%20fantasy%20webtoon%20style%2C%20elegant%20character%20design%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    tags: ["魔幻", "契约", "甜宠"],
    updateTime: "2026-07-02"
  },
  {
    id: 3,
    title: "暗影猎人",
    author: "朴志勋",
    category: "动作",
    rating: 9.7,
    status: "已完结",
    chapters: 156,
    views: "8900万",
    description: "在一个被暗影生物威胁的世界里，猎人们是唯一能对抗它们的存在。主角韩哲是一名失去记忆的前S级猎人，为了找回自己的过去，他不得不重新拿起武器，与伙伴们一起踏上猎杀暗影的征途。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20cool%20hunter%20with%20sword%20in%20dark%20urban%20setting%2C%20neon%20blue%20and%20black%20color%20scheme%2C%20dynamic%20pose%2C%20action%20webtoon%20style%2C%20clean%20simple%20background%2C%20dramatic%20lighting%20effects%2C%20high%20quality%20digital%20art%2C%20sharp%20character%20design&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    tags: ["战斗", "热血", "奇幻"],
    updateTime: "2026-01-15"
  },
  {
    id: 4,
    title: "总裁的替身情人",
    author: "崔美妍",
    category: "恋爱",
    rating: 9.3,
    status: "连载中",
    chapters: 92,
    views: "4560万",
    description: "因为长相酷似总裁的白月光，普通上班族姜素媛被卷入了一场替身游戏。冷酷总裁金泰亨用金钱买下了她一年的时间，却没想到在这一年里，自己先动了真心。而姜素媛发现真相后，这段关系还能继续吗？",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20CEO%20man%20and%20beautiful%20woman%20in%20luxury%20office%2C%20black%20white%20and%20red%20color%20palette%2C%20modern%20romance%20webtoon%20style%2C%20clean%20composition%2C%20sophisticated%20character%20design%2C%20soft%20dramatic%20lighting%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    tags: ["霸道总裁", "替身", "虐恋"],
    updateTime: "2026-07-01"
  },
  {
    id: 5,
    title: "无限逃生游戏",
    author: "郑宇成",
    category: "悬疑",
    rating: 9.5,
    status: "连载中",
    chapters: 68,
    views: "2870万",
    description: "高中生李在勋收到了一条神秘短信，随后被强制拉入了一个名为「无限游戏」的异空间。在这里，他必须在每个关卡中解开谜题、躲避追杀才能存活。随着游戏深入，他发现参与者们似乎都和一个十年前的失踪案有关。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20tense%20survival%20game%20scene%2C%20dark%20green%20and%20red%20color%20scheme%2C%20mysterious%20atmosphere%2C%20suspense%20webtoon%20style%2C%20clean%20simple%20composition%2C%20dramatic%20shadows%2C%20high%20quality%20digital%20art%2C%20intense%20character%20expression&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    tags: ["生存", "推理", "悬疑"],
    updateTime: "2026-06-30"
  },
  {
    id: 6,
    title: "我成了反派继母",
    author: "姜秀晶",
    category: "古风",
    rating: 9.4,
    status: "连载中",
    chapters: 78,
    views: "3450万",
    description: "现代女教师安秀莲穿越到了一本古风小说中，成为了那位恶名昭彰的反派继母。为了改变原著的悲惨结局，她决定用真心去关爱那个未来会成为大反派的继子。然而，她的温柔举动却意外吸引了冷漠丈夫的注意。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%20art%2C%20elegant%20noblewoman%20in%20traditional%20Korean%20hanbok%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20palace%20garden%20background%2C%20romantic%20historical%20webtoon%20style%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    tags: ["穿越", "古风", "治愈"],
    updateTime: "2026-06-29"
  },
  {
    id: 7,
    title: "校园恋爱法则",
    author: "尹多贤",
    category: "日常",
    rating: 9.2,
    status: "已完结",
    chapters: 112,
    views: "2340万",
    description: "普通的女高中生韩智恩在新学期遇到了三个完全不同类型的男生——阳光活泼的篮球队长、冷静沉稳的学生会会长、神秘孤僻的转校生。不擅长恋爱的她，在友情与爱情之间摇摆不定，一段青涩的校园恋爱故事就此展开。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%20art%2C%20cute%20high%20school%20students%20in%20uniform%2C%20cherry%20blossom%20spring%20background%2C%20soft%20pastel%20pink%20and%20blue%20colors%2C%20youth%20romance%20webtoon%20style%2C%20clean%20simple%20composition%2C%20bright%20natural%20lighting%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    tags: ["校园", "青春", "恋爱"],
    updateTime: "2026-03-20"
  },
  {
    id: 8,
    title: "爆笑江湖录",
    author: "赵敏浩",
    category: "搞笑",
    rating: 9.1,
    status: "连载中",
    chapters: 145,
    views: "6230万",
    description: "一个只想躺平摆烂的现代宅男，意外穿越到了一个武侠世界。在这个人人苦练武功的世界里，他用各种现代人的骚操作和清奇脑回路，把整个江湖搅得天翻地覆。笑点密集，节奏飞快，保证让你笑到停不下来！",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20funny%20martial%20arts%20character%20with%20exaggerated%20expression%2C%20bright%20yellow%20and%20orange%20color%20scheme%2C%20ancient%20Chinese%20style%20background%2C%20humorous%20webtoon%20style%2C%20clean%20composition%2C%20vibrant%20lighting%2C%20high%20quality%20digital%20illustration%2C%20cartoonish%20fun%20vibe&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    tags: ["穿越", "武侠", "搞笑"],
    updateTime: "2026-07-03"
  },
  {
    id: 9,
    title: "深渊之眼",
    author: "韩志浩",
    category: "悬疑",
    rating: 9.6,
    status: "连载中",
    chapters: 54,
    views: "1890万",
    description: "刑警姜道贤在调查一起连环失踪案时，发现所有受害者最后出现的地点都指向同一栋废弃公寓。当他深入调查时，发现自己能看到死者最后看到的画面。这些「死亡影像」引导他一步步接近真相，但也将他推向了深渊边缘。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20detective%20in%20dark%20abandoned%20building%2C%20cold%20blue%20and%20gray%20color%20scheme%2C%20eerie%20atmosphere%2C%20crime%20thriller%20webtoon%20style%2C%20clean%20composition%2C%20dramatic%20low%20key%20lighting%2C%20high%20quality%20digital%20art%2C%20intense%20mood&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    tags: ["悬疑", "犯罪", "超能力"],
    updateTime: "2026-06-28"
  },
  {
    id: 10,
    title: "公主的逆袭",
    author: "朴海英",
    category: "古风",
    rating: 9.5,
    status: "连载中",
    chapters: 103,
    views: "4120万",
    description: "被最信任的皇兄背叛，从尊贵的公主沦为阶下囚。重生回到三年前，李华妍发誓要改写自己的命运。这一次，她不再是那个天真善良的小公主，而是手握先机、步步为营的复仇者。宫廷权谋与虐心情感交织，让人欲罢不能。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20palace%20cover%20art%2C%20noble%20princess%20in%20luxurious%20hanbok%20with%20determined%20expression%2C%20gold%20and%20deep%20red%20color%20palette%2C%20palace%20interior%20background%2C%20historical%20drama%20webtoon%20style%2C%20clean%20elegant%20composition%2C%20warm%20dramatic%20lighting%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    tags: ["重生", "宫斗", "复仇"],
    updateTime: "2026-06-30"
  },
  {
    id: 11,
    title: "神级外卖员",
    author: "金载赫",
    category: "动作",
    rating: 9.3,
    status: "连载中",
    chapters: 76,
    views: "2670万",
    description: "前特种兵崔泰浩退伍后做起了外卖员，本以为生活会平淡无奇。直到某天他接了一个神秘订单，发现需要派送的不是食物，而是一个被追杀的小女孩。为了守护这个孩子，他重新拾起了尘封的战斗技能。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20cool%20delivery%20man%20on%20motorcycle%20in%20city%20night%2C%20orange%20and%20black%20color%20scheme%2C%20dynamic%20urban%20scene%2C%20action%20thriller%20webtoon%20style%2C%20clean%20composition%2C%20neon%20city%20lighting%2C%20high%20quality%20digital%20art%2C%20tense%20cinematic%20feel&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    tags: ["都市", "战斗", "守护"],
    updateTime: "2026-07-01"
  },
  {
    id: 12,
    title: "猫咪咖啡厅的秘密",
    author: "李瑞妍",
    category: "日常",
    rating: 9.0,
    status: "已完结",
    chapters: 64,
    views: "1560万",
    description: "厌倦了职场生活的金多美辞掉了工作，在一条安静的小巷里开了一家猫咪咖啡厅。每天和可爱的猫咪们一起度过的悠闲时光，治愈了来到这里的每一位客人。而一个偶然走进店里的音乐人，也为她的生活带来了意想不到的甜蜜变数。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20warm%20atmosphere%2C%20cream%20and%20mint%20green%20color%20palette%2C%20peaceful%20cafe%20interior%2C%20healing%20webtoon%20style%2C%20clean%20soft%20composition%2C%20warm%20natural%20lighting%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    tags: ["治愈", "美食", "恋爱"],
    updateTime: "2026-02-10"
  }
];

export const categories = [
  { slug: "romance", name: "恋爱", icon: "ri-heart-line", count: 328, color: "bg-primary-500" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line", count: 245, color: "bg-accent-500" },
  { slug: "action", name: "动作", icon: "ri-sword-line", count: 186, color: "bg-secondary-500" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line", count: 142, color: "bg-foreground-700" },
  { slug: "slice-of-life", name: "日常", icon: "ri-calendar-line", count: 98, color: "bg-primary-400" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line", count: 167, color: "bg-accent-400" },
  { slug: "historical", name: "古风", icon: "ri-ancient-gate-line", count: 115, color: "bg-secondary-400" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line", count: 73, color: "bg-foreground-600" },
];

export const bannerComics = [
  {
    id: 1,
    title: "星光坠落时",
    author: "金秀雅",
    rating: 9.6,
    tag: "今日最热",
  },
  {
    id: 3,
    title: "暗影猎人",
    author: "朴志勋",
    rating: 9.7,
    tag: "完结推荐",
  },
  {
    id: 8,
    title: "爆笑江湖录",
    author: "赵敏浩",
    rating: 9.1,
    tag: "本周新秀",
  },
];